module.exports = __webpack_public_path__ + "static/media/lefthg.693a766e.png";